import { X } from "lucide-react";
import { SearchTermForm } from "./SearchTermForm";

interface SearchTermsSectionProps {
  searchTerms: string[];
  onAddTerm: (data: { term: string }) => void;
  onRemoveTerm: (term: string) => void;
}

export const SearchTermsSection = ({ searchTerms, onAddTerm, onRemoveTerm }: SearchTermsSectionProps) => {
  return (
    <div className="space-y-4">
      <div>
        <h3 className="text-lg font-medium">Search Terms</h3>
        <p className="text-sm text-muted-foreground">Add search terms to help find this template</p>
      </div>

      <div className="flex flex-wrap gap-2">
        {searchTerms.map((term, index) => (
          <div key={index} className="flex items-center gap-1 bg-secondary px-3 py-1 rounded-full">
            <span>{term}</span>
            <button
              type="button"
              onClick={() => onRemoveTerm(term)}
              className="text-muted-foreground hover:text-foreground"
            >
              <X className="h-4 w-4" />
            </button>
          </div>
        ))}
      </div>

      <SearchTermForm onSubmit={onAddTerm} />
    </div>
  );
};
